module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'pp-album-grid': 1,
      'pp-album-grid--mobile-horizontal': _vm.mobileHorizontal
    },
    style: ({
      'max-height': _vm.maxRows ? ((_vm.$root.view == 'mobile' ? 212 : 230) * _vm.maxRows) + 'px' : ''
    })
  }, [_vm._l((_vm.realItems), function(item) {
    return _c('router-link', {
      key: item.id,
      class: {
        'pp-album-grid__item': 1,
        'pp-album-grid__item--loading': item.loading
      },
      attrs: {
        "to": '/browse/albums/' + item.id
      }
    }, [(item.realArtwork) ? _c('img', {
      staticClass: "pp-album-grid__item__artwork",
      attrs: {
        "src": item.realArtwork
      },
      on: {
        "load": function($event) {
          return _vm.$set(item, 'loading', false)
        }
      }
    }) : _vm._e(), _vm._v(" "), (!item.realArtwork) ? _c('div', {
      staticClass: "pp-album-grid__item__artwork pp-album-grid__item__artwork--placeholder"
    }, [_vm._v("\n            Pristine Classical\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "pp-album-grid__item__title",
      attrs: {
        "title": item.title
      }
    }, [_c('div', [_vm._v(_vm._s(item.title))])])])
  }), _vm._v(" "), (_vm.paginating) ? _c('loading-indicator') : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ac3e203","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AlbumGrid.vue
// module id = 122
// module chunks = 0 1